export const formatNumber = (value) => value.toLocaleString('pt-BR', { minimumFractionDigits: 2 });
export const formatPercent = (value) => value.toLocaleString('pt-BR', { style: 'percent', maximumFractionDigits: 2 });
export const formatCurrency = (value) => value.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL'
});
const getValueAsNumber = (value) => {
    if (isNaN(Number(value)))
        return 0;
    return Number(value);
};
export const formatValue = (value = 0, type = 'default') => {
    const valueNumber = getValueAsNumber(value);
    const formatters = {
        number: () => formatNumber(valueNumber),
        percent: () => formatPercent(valueNumber),
        currency: () => formatCurrency(valueNumber),
        default: () => valueNumber.toString()
    };
    return formatters[type] ? formatters[type]() : formatters.default();
};
export const removeCurrencyFormat = (value) => {
    if (!value)
        return null;
    const [number, decimal] = value.split(',');
    const asNumber = Number(number.replace(/\D/g, ''));
    if (decimal === '00')
        return asNumber;
    return asNumber + Number(`0.${decimal}`);
};
